import { Notification } from './../../../core/models/notification.model';
import { NotificationService } from './../../../core/services/notification.service';
import { WebsocketService } from './../../../core/services/websocket.service';
import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { Profile } from 'src/app/core/models/profile.model';
import { AuthService } from '../../../core/services/auth.service';
import { DesignService } from 'src/app/core/services/design.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { LoaderService } from 'src/app/core/loader.service';
import { Subscription } from 'rxjs';
import { NgxLinkifyOptions } from 'src/app/core/pipes/ngx-linkifyjs.interface';
import { formatDate } from '@angular/common';
import { User, UserService } from 'src/app/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ReportBugFeedbackDTO } from '../../../core/models/reportBugFeedback.modal';
import { NgForm } from '@angular/forms';
import Shepherd from 'shepherd.js';
import { NameSettingDTO } from '../../../core/models/nameSettting.modal';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  headerStyle: string;
  headerStyleSubscription: any;
  searchValue = '';
  searchSuggetionList: any[] = [];
  defaultProfile = new Profile();
  public profile = new Profile();
  firstLogin: boolean = false;
  verified: boolean = false;
  nonVerifiedUser = { firstName: '', lastName: '', userName: '' };
  logoutBtn: boolean = false;
  loginBtn: boolean = false;
  clickEventsubscription: Subscription;
  private claimSubscription?: Subscription;
  private notificationSubscriptions = new Subscription();
  notificationCount: number = 0;
  notificationList = new Array<Notification>();
  pageRequest: Number = 0;
  loading: string = 'none';
  isInAppear: boolean = false;
  welcomeMessage: boolean = false;
  todayDate: any;
  value: any;
  timestamp: number = Date.now();
  reportBugFeedbackDTO: ReportBugFeedbackDTO = new ReportBugFeedbackDTO();
  isHomepage: boolean = false;
  showSuggestions: boolean = false;

  navigation: any;
  textVerified = false;
  firstClick: boolean = false;
  invalidOTP: boolean = false;
  otpSent = false;
  otpResent = false;
  passwordMeter = false;

  public countryCode: string = '+1';
  public phoneNumber: string = '';
  countries: any[] = [];
  filteredCountries: any[] = [];
  countrySearchTerm: string = '';
  selectedCountry: any = null;
  countryDropdownOpen: boolean = false;
  errorMsg = null;
  accountSetUp = 0;
  verifyIdentity = 70;

  // activation code array
  actCodeArr: string[] = new Array(6);
  otpCodeArr: string[] = ['', '', '', ''];
  toDos: string[] = [];
  otp: string = '';
  userId: any;
  // error message from response
  errMsg: string = '';
  invalidPhone = false;
  // flag denoting invalid sign up state.
  invalidSignUp: boolean = false;
  // flag denoting wrong activation code.
  incorrectActCode: boolean = false;
  activationsent: boolean = false;

  // check user id fully verified or not
  fullyVerified = false;
  existPhoneNumber = false;
  validAge: boolean = true;
  diditVerified = false;
  diditStatus: string = '';
  diditErrMsg: string | null = null;
  otpResendBlocked: boolean = false;
  otpResendCooldownMsg: string = '';
  otpCooldownEndTime: Date | null = null;
  otpCooldownInterval: any = null;
  otpSendInFlight: boolean = false;
  private otpCooldownPerfBaseline: number | null = null;
  private otpCooldownDurationMs: number = 15 * 60 * 1000;
  private readonly OTP_COOLDOWN_STORAGE_PREFIX = 'otp_cooldown_state_';
  private readonly OTP_WINDOW_MS = 15 * 60 * 1000;
  private readonly OTP_MAX_ATTEMPTS = 3;
  phoneChangeError: string = '';
  otpVerificationError: string = '';

  private isLoadingNotifications = false; // add this property

  email: string = '';
  verificationCode: string = ';';
  phoneNoErrMsg: string = '';
  firstName = 'Alexandra';
  middleName = 'Marie';
  lastName = 'Nicholas-Dancy';

  visibility = {
    firstName: 'show',
    middleName: 'show',
    lastName: 'show',
  };
  keepAsIs = false;
  error = '';
  previewName = '';
  nameSettingDTO: NameSettingDTO = new NameSettingDTO();
  fullName = {
    prefix: '',
    firstName: '',
    middleName: '', // Optional
    lastName: '',
    suffix: '',
  };
  errorMessage = '';
  disable = false;
  isMenuOpen = false;
  // default false until we read server value
  emailNotificationsEnabled: boolean = false;

  public getUser() {
    return this.authService.getUser();
  }

  user = new User();

  options: NgxLinkifyOptions = {
    className: '',
    attributes(href: any, type: string) {
      type = 'linkify linkify-' + type;
      return { routerLink: href, class: type };
    },
    formatHref(href, type) {
      if (type === 'mention') {
        href = '/profile/view-profile/' + href.substring(1);
      }
      return href;
    },
    ignoreTags: ['script', 'style'],
    nl2br: true,
  };
  representativeList: Array<string> = [];

  @ViewChild('countrySearchInput') countrySearchInput!: ElementRef;

  constructor(
    private authService: AuthService,
    private designService: DesignService,
    private profileService: ProfileService,
    private router: Router,
    private loaderService: LoaderService,
    private websocketService: WebsocketService,
    private notificationService: NotificationService,
    private userService: UserService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.getUserDetails();
    this.headerStyle = designService.headerStyle;
    this.headerStyleSubscription =
      this.designService.headerStyleChange.subscribe((value) => {
        this.headerStyle = value;
      });

    this.clickEventsubscription = this.designService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

    // 🔥 REQUIRED – keeps websocket stream alive
    this.notificationSubscriptions.add(
      this.websocketService.updateNotificationCountViaWebSocket$.subscribe(
        (value) => {
          this.handleNotificationCountPayload(value);
        }
      )
    );

    this.notificationSubscriptions.add(
      this.websocketService.notificationReceived$.subscribe((data) => {
        this.handleNotificationCountPayload(data);
      })
    );
  }

  private handleNotificationCountPayload(payload: unknown) {
    const nextCount = this.extractNotificationCount(payload);

    if (nextCount === null || this.notificationCount === nextCount) {
      return;
    }

    this.notificationCount = nextCount;
    this.getNotifications();
  }

  private extractNotificationCount(payload: unknown): number | null {
    const normalizedPayload = this.parseNotificationPayload(payload);
    const responseData = this.unwrapNotificationResponseData(normalizedPayload);
    const nextCount =
      typeof responseData === 'string' ? Number(responseData) : responseData;

    return typeof nextCount === 'number' && Number.isFinite(nextCount)
      ? nextCount
      : null;
  }

  private parseNotificationPayload(payload: unknown): unknown {
    if (typeof payload !== 'string') {
      return payload;
    }

    try {
      return JSON.parse(payload);
    } catch (error) {
      console.error('WebSocket parse error', error);
      return payload;
    }
  }

  private unwrapNotificationResponseData(payload: unknown): unknown {
    if (
      payload &&
      typeof payload === 'object' &&
      'success' in payload &&
      'data' in payload
    ) {
      const response = payload as { success?: unknown; data?: unknown };

      if (response.success !== 0 || response.data == null) {
        return null;
      }

      return response.data;
    }

    return payload;
  }

  ngOnInit() {
    this.getProfile();
    this.router.events.subscribe(() => {
      // Check if the current URL is the homepage
      this.isHomepage = this.router.url === '/homepage';
    });
    this.todayDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
    this.user = this.authService.getUser();
    this.emailNotificationsEnabled = !Boolean(this.user?.isUnsubscribed);
    this.loadCountries();
    this.rehydrateCooldown();

    if (this.user != undefined) {
      this.email = this.user.email;
    }

    if (this.user != undefined && this.user.textVerified) {
      this.phoneNumber = this.user.phoneNumber;
    }
    // if (this.user != undefined && this.user.firstName != null && this.user.lastName != null) {
    //   const firstNameParts = this.user.firstName.trim().split(' ');

    //   this.fullName.firstName = firstNameParts[0] || '';
    //   this.fullName.middleName = firstNameParts.length > 1
    //     ? firstNameParts.slice(1).join(' ')
    //     : '';
    //   this.fullName.lastName = this.user.lastName.trim();
    // }

    if (this.authService.getLogflag() && this.user.defaultProfileId != null) {
      const params = new HttpParams().set(
        'profileId',
        this.user.defaultProfileId
      ); // getting profile Id from route.
      // APi call
      this.profileService.getProfileDetails(params).subscribe((res) => {
        if (res.success === 0) {
          // let temp = res.data.profileImage;
          // if (
          //   temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'jpeg' ||
          //   temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'png' ||
          //   temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'jpg' ||
          //   temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'test'
          // ) {
          //   this.defaultProfile.profileImage = temp;
          // } else {
          //   this.defaultProfile.profileImage = '';
          // }
          this.defaultProfile.profileImage = res.data.profileImage;
          // if (
          //   this.defaultProfile.profileImage.includes(
          //     'bioguide.congress.gov'
          //   ) == true
          // ) {
          //   this.defaultProfile.profileImage = '';
          // }
        }
      });
    }

    if (this.user == null || this.authService.getLogflag() == null) {
      this.logoutBtn = true;
      this.loginBtn = false;
    } else {
      this.logoutBtn = false;
      this.loginBtn = true;
    }

    if (this.user != null || this.authService.getLogflag()) {
      this.firstLogin = this.user['firstLogIn'];
      this.verified = this.user.verified;
      this.defaultProfile.profileName = this.user.defaultProfileName;
      this.defaultProfile.publicName = this.user.publicName;
      // let temp = this.user.defaultProfileImage;

      // if (temp != null) {
      //   if (
      //     temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'jpeg' ||
      //     temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'png' ||
      //     temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'jpg' ||
      //     temp.substring(temp.lastIndexOf('.') + 1, temp.length) === 'test'
      //   ) {
      //     this.defaultProfile.profileImage = temp;
      //   } else {
      //     this.defaultProfile.profileImage = '';
      //   }
      // }

      // if (
      //   this.defaultProfile.profileImage.includes('bioguide.congress.gov') ==
      //   true
      // ) {
      //   this.defaultProfile.profileImage = '';
      // }

      this.defaultProfile.tagName = this.user.defaultProfileTagName;
      //this.defaultProfile.id = this.user.defaultProfileId;
      this.nonVerifiedUser.firstName = this.user.firstName;
      this.nonVerifiedUser.lastName = this.user.lastName;
      this.nonVerifiedUser.userName = this.user.userName;

      this.pageRequest = 0;

      this.websocketService.ensureConnection();
      if (!this.claimSubscription) {
        this.claimSubscription = this.websocketService.claimReceived$.subscribe(
          (message: any) => {
            if (
              this.user &&
              this.user.userId &&
              message.userId &&
              String(this.user.userId) === String(message.userId)
            ) {
              if (message.status === 'APPROVED') {
                this.getUserDetails(() => {
                  $('#claimApprovedModal').modal('show');
                }, true);
              } else if (message.status === 'REJECTED') {
                this.getUserDetails(() => {
                  $('#claimRejectedModal').modal('show');
                }, true);
              }
            }
          }
        );
      }

      this.getNotificationCount();
      //on init notification data load.
      this.getNotifications();
    }
  }

  ngOnDestroy() {
    this.claimSubscription?.unsubscribe();
    this.notificationSubscriptions.unsubscribe();
    this.clickEventsubscription?.unsubscribe();
    this.headerStyleSubscription?.unsubscribe();
  }

  logOut() {
    // Remove logIn flag in authservice
    this.authService.removeLogFlag();
    // Remove cookies when logOut
    this.authService.removeCookie();
    //close connection of websocket
    // this.websocketService._disconnect();
    // Navigate to Url
    this.router.navigateByUrl('/login');
    this.closeNavbarCollepse();
  }

  // To search the profile based on the search string. Returns List of profiles matching the search string.

  headerSearchProfiles() {
    const trimmedValue = this.searchValue.trim();

    if (!trimmedValue) {
      return; // Prevent empty or whitespace-only searches
    }

    // Force full browser reload every time
    window.location.href = `/profile/view-profile/${trimmedValue}`;

    this.searchValue = '';
    this.searchSuggetionList = [];
  }

  searchSelect(value: any) {
    this.searchValue = value.tagName;
    this.headerSearchProfiles();
    $('.header-search').removeClass('small-screen-search');
  }
  checkLogin() {
    this.getUserDetails(() => {
      let user = this.authService.getUser();
      this.newpostModal();
      if (user != null) {
        if (user.verified) {
          if (user.defaultProfileId == null && user.reviewProfileId == null) {
            $('#restrictProfileModal').modal('show');
          }
          // else if (user.reviewProfileId != null) {
          //   $('#restrictUnclaimedProfileModal').modal('show');
          // }
          else {
            this.authService.setProfileName('');
            $('#conversionTabModal').modal('show');
          }
        } else {
          $('#restrictModal').modal('show');
        }
      } else {
        this.router.navigateByUrl('/login');
      }
    });
  }

  openFeedbackModal() {
    $('#haveFeedback').modal('show');
  }

  onChangeSearch(event: string) {
    // Trim leading and trailing spaces
    const trimmedEvent = event.trim();

    // Prevent search if the trimmed string is empty
    if (trimmedEvent === '') {
      this.searchSuggetionList = []; // Clear suggestions if the search string is empty
      // this.searchProfiles(); // Optionally call searchProfiles if needed
      return;
    }

    // Update search value
    this.searchValue = trimmedEvent;

    // Check for minimum length
    if (trimmedEvent.length > 1) {
      // Remove '@' from the beginning if present
      let searchTerm = trimmedEvent.startsWith('@')
        ? trimmedEvent.slice(1)
        : trimmedEvent;

      let params = new HttpParams()
        .set('tagNameSubString', searchTerm)
        .set('limit', '20');

      if (this.user && this.user.defaultProfileId) {
        params = params.set('profileId', this.user.defaultProfileId.toString());
      }

      this.profileService.getSuggestions(params).subscribe(
        (success) => {
          const newList: { tagName: any; displayName: string }[] = [];

          success.data.forEach((element: any) => {
            const tag = '@' + element.tagName;
            const displayName = `${tag}<br>${element.publicName}`;

            // Ensure there are no duplicates in the suggestions list
            if (!newList.some((e) => e.tagName === element.tagName)) {
              newList.push({ tagName: element.tagName, displayName });
            }
          });

          // Update list and detect changes
          this.searchSuggetionList = newList;
          this.value = this.searchSuggetionList[0];
        },
        (error) => {
          console.error('Error On Search:', error);
        }
      );
    }
  }

  //to get notification count
  getNotificationCount() {
    const profileId = this.getNotificationProfileId();
    if (profileId === null) {
      this.notificationCount = 0;
      return;
    }

    const params = new HttpParams().set('profileId', profileId.toString());
    this.notificationService
      .getNotificationCountByProfileId(params)
      .subscribe((res) => {
        const resdata = res;
        if (resdata.success === 0) {
          this.notificationCount = resdata.data;
        }
      });
  }

  //get All notification
  getNotifications() {
    if (this.isLoadingNotifications) return;

    const profileId = this.getNotificationProfileId();
    if (profileId === null) {
      this.notificationList = [];
      this.notificationCount = 0;
      this.welcomeMessage = false;
      return;
    }

    this.isLoadingNotifications = true;
    this.welcomeMessage = false;
    this.pageRequest = 0;
    if (this.authService.getLogflag()) {
      const params = new HttpParams()
        .set('profileId', profileId.toString())
        .set('start', this.pageRequest.toString())
        .set('limit', '10');
      this.notificationService.getNotificationsByProfileId(params).subscribe(
        (res) => {
          this.isLoadingNotifications = false;
          const resData = res;
          if (resData.success === 0) {
            this.notificationList = [];
            this.notificationList = resData.data;
            this.getNotificationCount(); // ✅ add back — it's safe, not part of the loop
          } else {
            this.notificationList = [];
          }
          if (
            this.notificationList.length === 0 ||
            this.notificationList.length < 6
          ) {
            this.welcomeMessage = true;
          }
        },
        () => {
          this.isLoadingNotifications = false;
        }
      );
    } else {
      this.isLoadingNotifications = false;
    }
  }

  //update isRead Flag & notification count when click on notification
  updateNotification(notification: Notification) {
    let notifcationId = notification.id;
    let isRead = notification.isRead;
    if (!isRead) {
      const params = new HttpParams()
        .set('notificationId', Number(notifcationId).toString())
        .set('isRead', 'true');
      this.notificationService
        .updateNotificationByNotificationId(params)
        .subscribe((res) => {
          const resData = res;
          if (resData.success === 0) {
            this.getNotifications();
            // this.notificationCount = Number(this.notificationCount) - 1;
          }
        });
    }
    this.routToNestedConversion(notification);
  }

  onAppear(event: any) {
    console.log('scroll call for notification');
    this.isInAppear = true;
    this.loading = '';
    this.pageRequest = Number(this.pageRequest) + 1;
    const profileId = this.getNotificationProfileId();
    if (profileId === null) {
      this.loading = 'none';
      this.isInAppear = false;
      return;
    }

    const params = new HttpParams()
      .set('profileId', profileId.toString())
      .set('start', this.pageRequest.toString())
      .set('limit', '10');
    this.notificationService
      .getNotificationsByProfileId(params)
      .subscribe((res) => {
        const resData = res;
        if (resData.success === 0) {
          let addNotifications = new Array<Notification>();
          addNotifications = resData.data;
          if (addNotifications.length !== 0) {
            addNotifications.forEach((notification) => {
              this.notificationList.push(notification);
            });
          } else {
            this.welcomeMessage = true;
          }
          //console.log('Appended notification list=' + this.notificationList);
        }
        this.loading = 'none';
        this.isInAppear = false;
      });
  }

  private getNotificationProfileId(): number | null {
    const profileIds = [
      this.user?.defaultProfileId,
      this.user?.reviewProfileId,
    ];

    for (const candidate of profileIds) {
      const profileId = Number(candidate);
      if (Number.isInteger(profileId) && profileId > 0) {
        return profileId;
      }
    }

    return null;
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    // visible height + pixel scrolled >= total height
    //if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
    console.log('End of notification scroll');
    if (this.isInAppear === false) {
      this.onAppear(event);
    }
    //}
  }

  routToNestedConversion(notification: Notification) {
    $('#mainMenuCollapse').collapse('hide');
    $('.extra-header').removeClass('collapsed-header');
    let url = '';

    if (notification.notification_type === 'MENTION') {
      url = notification.isReview
        ? `/profile/view-response/${notification.mentionReviewId}`
        : `/profile/review-response/${notification.reviewId}/${notification.mentionReviewId}`;
    } else if (notification.notification_type === 'ANNOUNCEMENT') {
      url = `/profile/view-announcement/${notification.announcementId}`;
    } else if (notification.notification_type === 'VIRTUAL_EVENT') {
      url = `/profile/view-virtual-event/${notification.byProfileTagName}/${notification.virtualEventId}`;
    } else if (
      notification.notification_type === 'NEW_POST' ||
      notification.notification_type === 'NEW_POLL'
    ) {
      url = `/profile/view-response/${notification.mentionReviewId}`;
    } else {
      url = `/profile/view-response/${notification.reviewId}`;
    }

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });
  }

  navigate() {
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  closeNavbarCollepse() {
    $('.navbar-collapse').removeClass('show');
    $('.extra-header').removeClass('collapsed-header');
    $('.navbar-is-expanded').removeClass('navbar-is-expanded');
    this.isMenuOpen = false;
  }

  goToReportAbuse(event: Event) {
    event.stopPropagation();
    document.body.click();
    this.router.navigate(['/report-abuse']);
    this.closeNavbarCollepse();
  }

  searchOpen() {
    $('.header-search').addClass('small-screen-search');
    $('.input-container input').focus();
  }
  searchClose() {
    $('.header-search').removeClass('small-screen-search');
  }

  removeTags(str: string) {
    if (str === null || str === '') return '';
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, '');
  }

  openCreatePageModal() {
    $('#createPageModal').modal('show');
  }

  redirectToCreateProfilePage() {
    //$('#createPageModal').modal('hide');
    this.router.navigate(['/profile/create-profile']);
  }

  onEnter(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;

    if (keyboardEvent.key === 'Enter') {
      const tagName = this.value?.tagName?.trim();

      if (tagName) {
        const targetUrl = `/profile/view-profile/${tagName}`;

        // Force full browser reload every time
        window.location.href = targetUrl;

        this.searchSuggetionList = [];
      } else {
        console.error('tagName is undefined or empty');
      }
    }
  }

  aboutus() {
    $('#aboutUsModal').modal('show');
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }
  yourPage() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.isMenuOpen = !this.isMenuOpen;
    }
    // $('.extra-header').removeClass('collapsed-header');
  }
  // onFocus(event: FocusEvent): void {
  //   event.stopImmediatePropagation();
  // }

  sendBugReportOrFeedback(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.reportBugFeedbackDTO.userId = this.user.userId;

    this.userService
      .sendBugReportOrFeedback(this.reportBugFeedbackDTO)
      .subscribe((res: any) => {
        const respData = res;
        if (respData.success == 0) {
          $('#haveFeedback').modal('hide');
          this.resetFormData(form);
        } else {
          $('#haveFeedback').modal('hide');
          this.resetFormData(form);
          console.log('Error while sending report bug or feedback');
        }
      });
  }

  resetFormData(form: NgForm) {
    form.resetForm();
    this.reportBugFeedbackDTO = new ReportBugFeedbackDTO();
    this.errMsg = '';
    this.activationsent = false;
    this.phoneNoErrMsg = '';
    this.otpResent = false;
    this.invalidOTP = false;
    this.incorrectActCode = false;
    setTimeout(() => {
      this.email = this.user.email;
      this.phoneNumber = this.user.phoneNumber;
      this.loadCountries();
    });
  }
  Updateaddress() {
    $('#UpdateAddressModal').modal('show');
  }

  verifymodal() {
    $('#UpdateAddressModal').modal('hide');
    $('#identityVerificationHeaderModal').modal('show');
    this.diditErrMsg = null;
    this.userService
      .createAndLaunchIdentityVerificationSession({
        person: {
          givenName: this.user.firstName,
          lastName: this.user.lastName,
        },
      })
      .catch((error) => {
        this.diditErrMsg =
          this.userService.showIdentityVerificationError(error);
      })
      .finally(() => {
        $('#identityVerificationHeaderModal').modal('hide');
      });
  }

  getRepresentative() {
    let address = this.user.address;
    if (address != undefined && address != null) {
      address = address.replace(/\n/g, ' ');
      this.loaderService.disable = true;

      this.profileService.getReprentatives(address).subscribe((res) => {
        if (res.success === 0) {
          console.log(JSON.stringify(res));
          res.data.forEach((obj: any) => {
            this.representativeList.push(obj.tagname);
          });
          console.log(
            'Representative List:' + JSON.stringify(this.representativeList)
          );
          this.authService.setRepresentativeList(this.representativeList);
          // window.location.reload();

          if (this.router.url.includes('view-response')) {
            console.log('URL contains "view-response", reloading page.');
            window.location.reload();
          }
        }
      });
    }
  }
  onFocus() {
    this.showSuggestions = true;
  }
  // Hide suggestions when input loses focus
  onBlur() {
    setTimeout(() => {
      this.showSuggestions = false;
    }, 200);
  }

  // Purpose : For updating user
  updateUser() {
    this.userService.editUser(this.user).subscribe((res) => {
      this.authService.setSessionData(this.user);
      if (res.success != 0) {
        console.log('Error while updating user');
      }
    });
  }

  closePopup() {
    window.location.reload();
  }
  phonoModal() {
    console.log('clicked');
    if (this.user && this.user.phoneNumber) {
      this.phoneNumber = this.user.phoneNumber;
    }
    this.loadCountries();
    this.rehydrateCooldown();
    $('#phoneNumberModalHeader').modal('show');
  }

  loadCountries() {
    if (this.countries.length === 0) {
      this.userService.getCountries().subscribe((res: any) => {
        if (res && res.success === 0) {
          this.countries = res.data;
          this.filteredCountries = res.data;

          let userCountryCode =
            localStorage.getItem('countryCode') ||
            (this.user ? this.user.countryCode : null);
          let userCountryIsoCode =
            localStorage.getItem('countryIsoCode') ||
            (this.user ? (this.user as any).countryIsoCode : null);

          const userCountry = this.findCountryForPhone(
            userCountryCode,
            userCountryIsoCode
          );
          if (userCountry) {
            this.selectedCountry = userCountry;
            this.countryCode = userCountry.callingCode;
          }

          if (!this.selectedCountry) {
            let defaultCountry = this.countries.find(
              (c) => c.name && c.name.toLowerCase() === 'united states'
            );
            if (!defaultCountry) {
              defaultCountry = this.countries.find(
                (c) => c.name && c.name.toLowerCase().includes('united states')
              );
            }
            if (!defaultCountry) {
              defaultCountry = this.countries.find(
                (c) => c.callingCode === '+1'
              );
            }
            if (defaultCountry) {
              this.selectedCountry = defaultCountry;
              this.countryCode = defaultCountry.callingCode;
            } else if (this.countries.length > 0) {
              this.selectedCountry = this.countries[0];
              this.countryCode = this.countries[0].callingCode;
            }
          }
        }
      });
    } else {
      let userCountryCode =
        localStorage.getItem('countryCode') ||
        (this.user ? this.user.countryCode : null);
      let userCountryIsoCode =
        localStorage.getItem('countryIsoCode') ||
        (this.user ? (this.user as any).countryIsoCode : null);

      const userCountry = this.findCountryForPhone(
        userCountryCode,
        userCountryIsoCode
      );
      if (userCountry) {
        this.selectedCountry = userCountry;
        this.countryCode = userCountry.callingCode;
      }
    }
  }

  changePhoneNumber() {
    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.getUserDetail(params).subscribe((res: any) => {
      if (res && res.success == 0) {
        const data = res.data;
        const phoneChangeCount = data.phoneChangeCount ?? 0;

        if (phoneChangeCount >= 2) {
          this.phoneChangeError =
            'You can only change phone number 2 times in 30 days.';
          return;
        }

        this.otpSent = false;
        this.otpCodeArr = ['', '', '', ''];
        this.otpResent = false;
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.otpResendBlocked = false;
        this.clearCooldownState();
      }
    });
  }

  resendOTP(form: NgForm) {
    if (this.otpSendInFlight || this.otpResendBlocked) {
      return;
    }
    form.resetForm();
    this.sendOTP(false);
    this.otpResent = true;
  }

  filterCountries() {
    if (!this.countrySearchTerm) {
      this.filteredCountries = this.countries;
    } else {
      this.filteredCountries = this.countries.filter(
        (c) =>
          (c.name &&
            c.name
              .toLowerCase()
              .includes(this.countrySearchTerm.toLowerCase())) ||
          (c.callingCode && c.callingCode.includes(this.countrySearchTerm))
      );
    }
  }

  private findCountryForPhone(
    countryCode: string | null | undefined,
    countryIsoCode: string | null | undefined
  ): any | null {
    if (!countryCode) {
      return null;
    }

    const exactCountry = this.countries.find(
      (country) =>
        country.callingCode === countryCode &&
        country.countryIsoCode === countryIsoCode
    );
    if (exactCountry) {
      return exactCountry;
    }

    if (countryCode === '+1') {
      const unitedStates = this.countries.find(
        (country) =>
          country.callingCode === '+1' && country.countryIsoCode === 'US'
      );
      if (unitedStates) {
        return unitedStates;
      }
    }

    return (
      this.countries.find((country) => country.callingCode === countryCode) ??
      null
    );
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.countryCode = country.callingCode;
    this.countryDropdownOpen = false;
    this.countrySearchTerm = '';
    this.filteredCountries = this.countries;
  }

  toggleCountryDropdown(event: Event) {
    event.stopPropagation();
    this.countryDropdownOpen = !this.countryDropdownOpen;
    if (this.countryDropdownOpen) {
      this.countrySearchTerm = '';
      this.filteredCountries = this.countries;
      setTimeout(() => {
        if (this.countrySearchInput) {
          this.countrySearchInput.nativeElement.focus();
        }
      }, 100);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.country-code-dropdown')) {
      this.countryDropdownOpen = false;
    }
  }
  //to send OTP
  sendOTP(invalid: any) {
    if (invalid) {
      return;
    }
    if (this.phoneNumber != null && this.user.phoneNumber == this.phoneNumber) {
      this.phoneNoErrMsg =
        'You have entered the same phone no. Please enter a new phone no.';
      return;
    }
    if (this.otpSendInFlight || this.otpResendBlocked) {
      return;
    }

    // Expire the 15-min window if it has already lapsed
    if (this.user.otpFirstRequestTime) {
      let firstTimeStr = this.user.otpFirstRequestTime;
      if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
      const elapsed = Date.now() - new Date(firstTimeStr).getTime();
      if (elapsed >= this.OTP_WINDOW_MS) {
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.clearPersistedCooldown();
      }
    }

    // Frontend 3-attempt block
    if (
      (this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS &&
      this.user.otpFirstRequestTime
    ) {
      let firstTimeStr = this.user.otpFirstRequestTime;
      if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
      this.otpCooldownEndTime = new Date(
        new Date(firstTimeStr).getTime() + this.OTP_WINDOW_MS
      );
      this.otpResendBlocked = true;
      this.startCooldownTimer();
      return;
    }

    this.otpSendInFlight = true;
    this.loaderService.disable = true;

    //API call
    this.recaptchaV3Service.execute('send_otp').subscribe(
      (token: string) => {
        const payload = {
          userId: this.user.userId.toString(),
          countryCode: this.countryCode,
          countryIsoCode: this.selectedCountry
            ? this.selectedCountry.countryIsoCode
            : '',
          phoneNumber: this.phoneNumber.toString(),
          updatedFlag: true,
          recaptchaToken: token, // passing the token as payload body
        };

        this.userService.sendOTP(payload).subscribe(
          (res) => {
            const respData = res;
            if (respData.success == 0) {
              this.phoneChangeError = '';

              if (!this.user.otpFirstRequestTime) {
                this.user.otpFirstRequestTime = new Date().toISOString();
              }
              this.user.otpRequestCount = (this.user.otpRequestCount ?? 0) + 1;
              this.persistOtpCounts();

              if ((this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS) {
                let firstTimeStr = this.user.otpFirstRequestTime;
                if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
                this.otpCooldownEndTime = new Date(
                  new Date(firstTimeStr).getTime() + this.OTP_WINDOW_MS
                );
                this.otpResendBlocked = true;
                this.startCooldownTimer();
              }

              $('#phoneNumberModalHeader').modal('hide');
              $('#phoneOtpModal').modal('show');
              this.otpSendInFlight = false;
              this.loaderService.disable = false;
              return;
            } else {
              this.loaderService.disable = false;
              this.otpResent = false;

              const backendMsg = (respData.message || '').toString();
              const isOtpLimitMsg = /otp\s*limit|try again after/i.test(
                backendMsg
              );
              this.phoneChangeError =
                backendMsg ||
                'Unable to send a verification code. Please try again.';

              if (!isOtpLimitMsg) {
                this.otpSendInFlight = false;
                return;
              }

              const params = new HttpParams().set(
                'userId',
                this.user.userId.toString()
              );
              this.userService.getUserDetail(params).subscribe(
                (res: any) => {
                  if (res.success == 0) {
                    this.user.phoneChangeCount = res.data.phoneChangeCount;
                    this.user.otpRequestCount = res.data.otpRequestCount;
                    this.user.otpFirstRequestTime =
                      res.data.otpFirstRequestTime;
                    this.user.firstChangeTime = res.data.firstChangeTime;
                    this.authService.setSessionData(this.user);

                    if (
                      isOtpLimitMsg ||
                      (this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS
                    ) {
                      this.phoneChangeError = '';
                      this.otpResendBlocked = true;
                      const cooldownMs = this.OTP_WINDOW_MS;

                      if (this.user.otpFirstRequestTime) {
                        let firstReqTime = this.user.otpFirstRequestTime;
                        if (!firstReqTime.endsWith('Z')) firstReqTime += 'Z';
                        const windowStart = new Date(firstReqTime);
                        const elapsed =
                          new Date().getTime() - windowStart.getTime();
                        const remaining = Math.max(cooldownMs - elapsed, 0);
                        this.otpCooldownEndTime = new Date(
                          new Date().getTime() +
                            (remaining > 0 ? remaining : cooldownMs)
                        );
                      } else {
                        this.otpCooldownEndTime = new Date(
                          new Date().getTime() + cooldownMs
                        );
                      }

                      this.persistOtpCounts();
                      this.startCooldownTimer();
                    } else if (
                      this.user.phoneChangeCount &&
                      this.user.phoneChangeCount >= 2
                    ) {
                      this.phoneNoErrMsg = '';
                      this.phoneChangeError =
                        'You can change phone number only 2 times in 30 days.';
                      this.otpResendBlocked = false;
                    } else if (backendMsg) {
                      this.phoneChangeError = backendMsg;
                      this.otpResendBlocked = false;
                    }
                  }
                  this.otpSendInFlight = false;
                },
                () => {
                  this.otpSendInFlight = false;
                }
              );
            }
          },
          (error) => {
            console.error('sendOTP API failed:', error);
            this.phoneChangeError =
              error?.error?.message ||
              'Unable to send a verification code. Please try again.';
            this.loaderService.disable = false;
            this.otpSendInFlight = false;
          }
        );
      },
      (error) => {
        console.error('reCAPTCHA execution failed:', error);
        this.phoneChangeError =
          'Unable to verify your request. Please try again.';
        this.loaderService.disable = false;
        this.otpSendInFlight = false;
      }
    );
  }

  //to verify OTP
  otpVerify(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.loaderService.disable = true;

    this.otp = this.otpCodeArr.join('');
    //API call
    const params = new HttpParams()
      .set('userId', this.user.userId.toString())
      .set('otp', this.otp);
    this.userService.verifyOTP(params).subscribe(
      (res: any) => {
        const respData = res;
        if (respData.success == 1) {
          this.invalidOTP = true;
          this.otpVerificationError =
            respData.message ||
            'The verification code is invalid or expired. Request a new code.';
          this.loaderService.disable = false;
          return;
        } else {
          form.resetForm();
          $('#phoneOtpModal').modal('hide');
          this.invalidOTP = false;
          this.otpVerificationError = '';
          this.otpSent = false;
          this.otpResent = false;
          this.otpCodeArr = new Array(4).fill('');
          this.user.otpRequestCount = 0;
          this.user.otpFirstRequestTime = '';
          this.otpResendBlocked = false;
          this.clearCooldownState();

          localStorage.setItem('countryCode', this.countryCode);
          if (this.selectedCountry) {
            localStorage.setItem(
              'countryIsoCode',
              this.selectedCountry.countryIsoCode
            );
          }

          const params = new HttpParams().set(
            'userId',
            this.user.userId.toString()
          );
          this.userService.getUserDetail(params).subscribe(
            (res: any) => {
              const respData = res;
              if (respData.success == 0) {
                Object.assign(this.user, respData.data);
                this.authService.setSessionData(this.user);
                this.phoneNumber = respData.data.phoneNumber;
              }
              this.loaderService.disable = false;
            },
            () => {
              this.loaderService.disable = false;
            }
          );
        }
      },
      (error) => {
        this.invalidOTP = true;
        this.otpVerificationError =
          error?.error?.message ||
          'Unable to verify the code. Please try again.';
        this.loaderService.disable = false;
      }
    );
  }
  onPestCode(event: ClipboardEvent, id: any, len: any) {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData('text').trim();
    let myIndex = 0;
    const element = document.getElementById(`${id}${len - 1}`);
    if (element) {
      (element as HTMLInputElement).focus();
    }
    for (var i = 0; i < len; i++) {
      const myIndex2 = id + myIndex;
      const input: any = document.getElementById(myIndex2);

      // pest value in array
      input.value = pastedText.charAt(i);
      const event = new Event('input', {
        bubbles: true,
        cancelable: true,
      });
      input.dispatchEvent(event);

      // pest value in input view
      input.value = pastedText.charAt(i);

      myIndex = myIndex + 1;
    }
  }
  keytab(myIndex: any, key: any, event: any) {
    if (event === 'keyup' && (key.keyCode === 8 || key.keyCode === 46)) {
      key.target.value = '';
      if (myIndex > 0) {
        myIndex = myIndex - 1;
        const myIndex2 = 'activationCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      }
    }
    if (event === 'input' && myIndex < 5 && key.target.value !== '') {
      if (key.data in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) {
        myIndex = myIndex + 1;
        const myIndex2 = 'activationCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      } else {
        key.target.value = '';
      }
    }
  }

  keytabOTP(myIndex: any, key: any, event: any) {
    if (event === 'keyup' && (key.keyCode === 8 || key.keyCode === 46)) {
      key.target.value = '';
      if (myIndex > 0) {
        myIndex = myIndex - 1;
        const myIndex2 = 'otpCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      }
    }
    if (event === 'input' && myIndex < 3 && key.target.value !== '') {
      if (key.data in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) {
        myIndex = myIndex + 1;
        const myIndex2 = 'otpCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      } else {
        key.target.value = '';
      }
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }
  updateemail() {
    $('#emailModal').modal('show');
  }
  setotp() {
    $('#otpModal').modal('show');
    $('#emailModal').modal('hide');
  }

  // To update email or phone no.
  updateEmailOrPhoneNo(
    countryCode: string,
    phoneNo: string,
    email: string,
    form: NgForm
  ) {
    if (form.invalid) {
      return;
    }
    if (this.email != '' && this.email === this.user.email) {
      this.errMsg =
        'You have entered the same email. Please enter a new email.';
      return;
    }
    if (this.user != undefined) {
      let params = new HttpParams();

      if (email != '') {
        params = params.append('email', this.email);
      }
      if (countryCode != '' && phoneNo != '') {
        params = params.append('countryCode', this.countryCode);
        params = params.append('phoneNo', this.phoneNumber);
      }

      this.userService
        .updateEmailOrPhoneNumber(params)
        .subscribe((res: any) => {
          console.log(
            'UpdateEmailOrPhoneNumber API Response:' + JSON.stringify(res)
          );
          if (res.success == 0 && email != '') {
            $('#otpModal').modal('show');
            $('#emailModal').modal('hide');
          } else if (res.success == 0 && phoneNo != '') {
            $('#phoneNumberModalHeader').modal('show');
          } else {
            this.errMsg = res.message;
          }
        });
    }
  }

  // To verify activation code
  activationCodeVerify(invalid: any) {
    if (invalid) {
      return;
    }

    this.verificationCode = this.actCodeArr.join('');

    const params = new HttpParams()
      .set('userId', this.user.userId.toString())
      .set('activationCode', this.verificationCode)
      .set('email', this.email);

    this.userService.activationCodeVerify(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.incorrectActCode = true;
        return;
      } else {
        this.incorrectActCode = false;
        $('#otpModal').modal('hide');
        $('#emailSucessfully').modal('show');
      }
    });
  }

  //  this method is called when clicking the resend button in update email popup.
  resendActivationCode(form: NgForm) {
    form.resetForm();
    const params = new HttpParams()
      .set('userId', this.user.userId.toString())
      .set('updatedflag', true)
      .set('updatedEmail', this.email);
    this.userService.resendActivationCode(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
      } else {
        this.activationsent = true;
      }
    });
    return;
  }

  onFocusEvent(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    target.select();
  }

  getUserDetails(callback?: () => void, skipClickEvent = false) {
    this.user = this.authService.getUser();
    if (this.user != undefined) {
      const params = new HttpParams().set(
        'userId',
        this.user.userId.toString()
      );
      this.userService.getUserDetail(params).subscribe((res: any) => {
        const respData = res;
        // Apply user data when response contains data object (robust for varied API success flags)
        if (respData && respData.data) {
          // ... all your existing assignments ...
          this.user.defaultProfileId = respData.data.defaultProfileId;
          this.user.defaultProfileTagName = respData.data.defaultProfileTagName;
          this.user.defaultProfileName = respData.data.defaultProfileName;
          this.user.publicName = respData.data.publicName;
          this.user.reviewProfileId = respData.data.reviewProfileId;
          this.user.isSubscribedToVirtualEvents =
            respData.data.isSubscribedToVirtualEvents;
          this.defaultProfile.tagName = this.user.defaultProfileTagName;
          this.defaultProfile.publicName = respData.data.publicName;
          if (this.user.defaultProfileId != null) {
            this.defaultProfile.id = this.user.defaultProfileId;
          }
          this.user.isPolitician = respData.data.isPolitician;
          this.user.countryCode = respData.data.countryCode;
          this.user.countryIsoCode = respData.data.countryIsoCode;
          this.applyEmailNotificationSetting(respData.data);
          this.authService.setSessionData(this.user);
          if (!skipClickEvent) {
            // ← only fire when needed
            this.designService.sendClickEvent();
          }
          if (callback) callback();
        }
      });
    }
  }

  applyEmailNotificationSetting(userData: any) {
    if (
      userData?.isEmailNotified !== undefined &&
      userData?.isEmailNotified !== null
    ) {
      this.emailNotificationsEnabled = Boolean(userData.isEmailNotified);
      this.user.isUnsubscribed = !this.emailNotificationsEnabled;
      return;
    }

    this.user.isUnsubscribed = Boolean(userData?.isUnsubscribed);
    this.emailNotificationsEnabled = !this.user.isUnsubscribed;
  }

  updateEmailNotifications(value: boolean) {
    const previousValue = this.emailNotificationsEnabled;
    this.emailNotificationsEnabled = value;

    if (!this.user || !this.user.userId) {
      this.emailNotificationsEnabled = previousValue;
      return;
    }

    const isEmailNotified = value;

    this.userService.updateEmailNotificationSetting(isEmailNotified).subscribe(
      (res: any) => {
        if (res?.success === 0) {
          this.getUserDetails(undefined, true);
          return;
        }
        this.emailNotificationsEnabled = previousValue;
      },
      () => {
        this.emailNotificationsEnabled = previousValue;
      }
    );
  }

  deleteNotification(notificationId?: number, event?: Event) {
    // event.stopPropagation();
    event?.stopPropagation();
    let params = new HttpParams();

    if (this.user.defaultProfileId != null) {
      params = params.set('profileId', this.user.defaultProfileId.toString());
    }

    if (notificationId !== undefined && notificationId !== null) {
      params = params.set('notificationId', notificationId);
    }
    this.notificationService.deleteNotification(params).subscribe((res) => {
      console.log('Delete notification API Response:' + res);
      if (res.success === 0) {
        this.getNotifications();
        this.getNotificationCount();
      }
    });
  }
  navigateToHome(event: Event) {
    // event.preventDefault();  // Prevent default anchor behavior
    event.stopPropagation();
    // event.stopImmediatePropagation();
    this.router.navigate(['/homepage']).then(() => {
      // Wait for navigation to complete, then collapse navbar
      setTimeout(() => {
        const navbar = document.querySelector('.navbar-is-expanded');
        if (navbar) {
          navbar.classList.remove('navbar-is-expanded'); // Remove expanded class
        }
      }, 100); // Small delay to ensure the class is removed after navigation
    });
  }

  fetchNameSetting() {
    this.user = this.authService.getUser();
    if (this.user != undefined && this.user.defaultProfileId != null) {
      const params = new HttpParams().set(
        'profileId',
        this.user.defaultProfileId.toString()
      );
      this.profileService.fetchNameSetting(params).subscribe((res: any) => {
        if (res.success == 0) {
          console.log(
            'Name settings fetched successfully:' + JSON.stringify(res)
          );
          if (res.data) {
            this.nameSettingDTO = res.data;
          } else {
            this.nameSettingDTO = new NameSettingDTO();
            this.nameSettingDTO.profileId = this.user.defaultProfileId;
          }

          if (this.nameSettingDTO.nameDisplayPreference == null) {
            this.nameSettingDTO.nameDisplayPreference = Object.assign(
              new NameSettingDTO().nameDisplayPreference,
              {
                firstName: 'full',
                middleName: 'full',
                lastName: 'full',
                prefix: 'hide',
                suffix: 'hide',
                customFirstName: this.fullName.firstName,
                customMiddleName: this.fullName.middleName,
                customLastName: this.fullName.lastName,
                keepAsIs: false,
              }
            );
          } else {
            this.nameSettingDTO.nameDisplayPreference.customFirstName =
              this.nameSettingDTO.nameDisplayPreference.customFirstName == null
                ? this.fullName.firstName
                : this.nameSettingDTO.nameDisplayPreference.customFirstName;
            this.nameSettingDTO.nameDisplayPreference.customMiddleName =
              this.nameSettingDTO.nameDisplayPreference.customMiddleName == null
                ? this.fullName.middleName
                : this.nameSettingDTO.nameDisplayPreference.customMiddleName;
            this.nameSettingDTO.nameDisplayPreference.customLastName =
              this.nameSettingDTO.nameDisplayPreference.customLastName == null
                ? this.fullName.lastName
                : this.nameSettingDTO.nameDisplayPreference.customLastName;
          }
        } else {
          this.nameSettingDTO.nameDisplayPreference = {
            firstName: 'full',
            middleName: 'full',
            lastName: 'full',
            prefix: 'hide',
            suffix: 'hide',
            customFirstName: this.fullName.firstName,
            customMiddleName: this.fullName.middleName,
            customLastName: this.fullName.lastName,
            keepAsIs: false,
          };
        }
        this.generatePreview();
      });
    }
  }

  updateNameSetting() {
    this.generatePreview();
    if (this.user.defaultProfileId != null) {
      this.nameSettingDTO.profileId = this.user.defaultProfileId;
    }
    console.log('namesetting object:' + JSON.stringify(this.nameSettingDTO));
    this.profileService
      .updateNameSetting(this.nameSettingDTO)
      .subscribe((res: any) => {
        if (res.success == 0) {
          console.log(
            'Name settings updated successfully:' + JSON.stringify(res)
          );
          $('#namePrefModal').modal('hide');
        } else {
          $('#namePrefModal').modal('hide');
        }
      });
  }

  generatePreview(): void {
    const pref = this.nameSettingDTO.nameDisplayPreference;
    const fullName = this.fullName;
    const middleExists = !!fullName.middleName?.trim();
    const prefixExists = !!fullName.prefix?.trim();
    const suffixExists = !!fullName.suffix?.trim();

    this.errorMessage = '';
    this.disable = false;

    if (pref.keepAsIs) {
      const nameParts = [
        fullName.prefix,
        fullName.firstName,
        fullName.middleName,
        fullName.lastName,
        fullName.suffix,
      ].filter(Boolean);
      this.previewName = nameParts.join(' ').trim();
      this.nameSettingDTO.publicName = this.previewName;
      return;
    }

    // Validation: hide limits
    if (middleExists) {
      const hiddenCount = [
        pref.firstName,
        pref.middleName,
        pref.lastName,
      ].filter((v) => v === 'hide').length;
      if (hiddenCount > 1) {
        this.errorMessage = 'You can hide only one of the three names.';
        this.disable = true;
        this.previewName = '';
        return;
      }
    }

    if (pref.firstName === 'hide' && pref.lastName === 'hide') {
      this.errorMessage = 'You cannot hide both First Name and Last Name.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    const fullShown =
      pref.firstName === 'full' ||
      (middleExists && pref.middleName === 'full') ||
      pref.lastName === 'full';

    if (
      !fullShown &&
      pref.firstName !== 'custom' &&
      pref.middleName !== 'custom' &&
      pref.lastName !== 'custom'
    ) {
      this.errorMessage = 'At least one name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      pref.firstName === 'initial' &&
      (!pref.middleName || pref.middleName === 'initial') &&
      pref.lastName === 'initial'
    ) {
      this.errorMessage =
        'At least one of First, Middle, or Last Name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      !middleExists &&
      (pref.firstName === 'hide' || pref.lastName === 'hide')
    ) {
      this.errorMessage =
        'You cannot hide names unless middle name is available.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      pref.firstName !== 'full' &&
      pref.lastName !== 'full' &&
      (!middleExists || pref.middleName !== 'full')
    ) {
      this.errorMessage =
        'At least one of First, Middle, or Last Name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    // 🚨 Custom name validation
    const customFields: {
      field: keyof typeof pref;
      original: string;
      input: string;
    }[] = [
      {
        field: 'firstName',
        original: fullName.firstName,
        input: this.nameSettingDTO.nameDisplayPreference.customFirstName,
      },
      {
        field: 'middleName',
        original: fullName.middleName || '',
        input: this.nameSettingDTO.nameDisplayPreference.customMiddleName,
      },
      {
        field: 'lastName',
        original: fullName.lastName,
        input: this.nameSettingDTO.nameDisplayPreference.customLastName,
      },
    ];

    const normalize = (s: string) =>
      (s || '')
        .normalize?.('NFKD') // decompose accents
        .replace(/[\u0300-\u036f]/g, '') // remove combining diacritics
        .replace(/[^\w\s]/g, '') // drop punctuation (keeps letters/numbers/underscore)
        .replace(/\s+/g, ' ') // collapse multiple spaces
        .toLowerCase()
        .trim();

    // 🚨 Robust Custom name validation (permits substrings, order-agnostic)
    for (const { field, original, input } of customFields) {
      if (pref[field] === 'custom') {
        const rawInput = (input ?? '').trim();

        // 🚨 Blank input check
        if (!rawInput) {
          this.errorMessage = `Custom ${field.replace(
            'Name',
            ' Name'
          )} cannot be blank.`;
          this.disable = true;
          this.previewName = '';
          return;
        }

        const normOriginal = normalize(original);
        const normInput = normalize(rawInput);

        const inputWords = normInput.split(' ').filter(Boolean);

        // ✅ each input word must appear as substring in the original
        const allWordsPresent = inputWords.every((w) =>
          normOriginal.includes(w)
        );

        if (!allWordsPresent) {
          this.errorMessage =
            'Custom name must be a part of your profile name.';
          this.disable = true;
          this.previewName = '';
          return;
        }
      }
    }

    // ✅ Build the preview
    const first =
      pref.firstName === 'full'
        ? fullName.firstName
        : pref.firstName === 'initial'
        ? fullName.firstName?.charAt(0) + '.'
        : pref.firstName === 'custom'
        ? this.nameSettingDTO.nameDisplayPreference.customFirstName?.trim()
        : '';

    const middle = middleExists
      ? pref.middleName === 'full'
        ? fullName.middleName
        : pref.middleName === 'initial'
        ? fullName.middleName
            .split(' ')
            .filter((part) => part.trim().length > 0)
            .map((part) => part.charAt(0) + '.')
            .join(' ')
        : pref.middleName === 'custom'
        ? this.nameSettingDTO.nameDisplayPreference.customMiddleName?.trim()
        : ''
      : '';

    const last =
      pref.lastName === 'full'
        ? fullName.lastName
        : pref.lastName === 'initial'
        ? fullName.lastName
            .split(' ')
            .filter((part) => part.trim().length > 0)
            .map((part) => part.charAt(0) + '.')
            .join(' ')
        : pref.lastName === 'custom'
        ? this.nameSettingDTO.nameDisplayPreference.customLastName?.trim()
        : '';

    const prefix =
      prefixExists && pref.prefix === 'full' ? fullName.prefix : '';

    const suffix =
      suffixExists && pref.suffix === 'full' ? fullName.suffix : '';

    const parts = [prefix, first, middle, last, suffix].filter(Boolean);
    this.previewName = parts.join(' ').trim();
    this.nameSettingDTO.publicName = this.previewName;
  }

  onKeepAsIsChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.nameSettingDTO.nameDisplayPreference.keepAsIs = isChecked;

    if (isChecked) {
      this.nameSettingDTO.nameDisplayPreference.firstName = 'full';
      this.nameSettingDTO.nameDisplayPreference.middleName = 'full';
      this.nameSettingDTO.nameDisplayPreference.lastName = 'full';
      this.nameSettingDTO.nameDisplayPreference.prefix =
        this.fullName.prefix != null ? 'full' : 'hide';
      this.nameSettingDTO.nameDisplayPreference.suffix =
        this.fullName.suffix != null ? 'full' : 'hide';
    }

    this.generatePreview();
  }

  nameSettingModal() {
    this.loaderService.show();
    this.fetchNameSetting();
    $('#namePrefModal').modal('show');
    this.loaderService.hide();
  }

  closeNameSettingPopup() {
    this.errorMessage = '';
    this.disable = false;
    this.fetchNameSetting();
  }

  // Purpose : To get profile details
  getProfile() {
    if (this.user != null && this.user.defaultProfileId != null) {
      const params = new HttpParams().set(
        'profileId',
        this.user.defaultProfileId.toString()
      );
      this.profileService.getProfileV1(params).subscribe((res) => {
        if (res.success === 0) {
          this.profile = res.data;
          if (this.user.name) {
            this.fullName.suffix = this.user.name.suffix;
            this.fullName.firstName = this.user.name.firstName;
            this.fullName.middleName = this.user.name.middleName;
            this.fullName.lastName = this.user.name.lastName;
            this.fullName.suffix = this.user.name.suffix;
          }
          // const nameParts = this.profile.profileName.trim().split(/\s+/);

          // this.fullName.firstName = nameParts[0] || '';
          // this.fullName.lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '';
          // this.fullName.middleName = nameParts.length > 2
          //   ? nameParts.slice(1, nameParts.length - 1).join(' ')
          //   : '';
        }
      });
    }
  }

  // Purpose : To update virtual event notification setting
  virtualEventNotification(value: boolean) {
    if (this.user != null && this.user.defaultProfileId != null) {
      const params = new HttpParams().set(
        'userId',
        this.user.userId.toString()
      );
      this.userService.virtualEventNotification(params).subscribe((res) => {
        if (res.success === 0) {
          this.user.isSubscribedToVirtualEvents = value;
          this.authService.setSessionData(this.user);
        }
      });
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // newpostModal(){
  //  const isMobile = window.innerWidth <= 767;
  //  if(isMobile){
  //   this.isMenuOpen = !this.isMenuOpen;
  //  }
  // }
  newpostModal() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }

  approvedOk() {
    this.getUserDetails(() => {
      window.location.reload();
    });
  }

  rejectedOk() {
    this.getUserDetails(() => {
      this.router.navigate(['/profile/search-profile']);
    });
  }

  startCooldownTimer() {
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }

    if (this.otpCooldownEndTime) {
      const remainingNow = Math.max(
        this.otpCooldownEndTime.getTime() - Date.now(),
        0
      );
      this.otpCooldownPerfBaseline = performance.now();
      this.otpCooldownDurationMs = remainingNow;
      this.persistCooldown(this.otpCooldownEndTime);
    }

    const tick = () => {
      if (!this.otpCooldownEndTime) {
        clearInterval(this.otpCooldownInterval);
        return;
      }

      let remaining: number;
      if (this.otpCooldownPerfBaseline != null) {
        remaining =
          this.otpCooldownDurationMs -
          (performance.now() - this.otpCooldownPerfBaseline);
      } else {
        remaining = this.otpCooldownEndTime.getTime() - Date.now();
      }

      if (remaining <= 0) {
        clearInterval(this.otpCooldownInterval);
        this.otpResendBlocked = false;
        this.otpResendCooldownMsg = '';
        this.otpCooldownEndTime = null;
        this.otpCooldownPerfBaseline = null;
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.clearPersistedCooldown();
      } else {
        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const mm = String(minutes).padStart(2, '0');
        const ss = String(seconds).padStart(2, '0');
        this.otpResendCooldownMsg = `OTP limit reached. Try again after ${mm}:${ss} minutes`;
      }
    };
    tick();
    this.otpCooldownInterval = setInterval(tick, 1000);
  }
  clearCooldownState() {
    this.user.otpRequestCount = 0;
    this.user.otpFirstRequestTime = '';
    this.otpResendBlocked = false;
    this.otpResendCooldownMsg = '';
    this.otpCooldownEndTime = null;
    this.otpCooldownPerfBaseline = null;
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }
    this.clearPersistedCooldown();
  }

  private getCooldownStorageKey(): string {
    const uid = this.user?.userId ? this.user.userId.toString() : 'anon';
    return this.OTP_COOLDOWN_STORAGE_PREFIX + uid;
  }

  private persistCooldown(endTime: Date) {
    try {
      const state = {
        endTime: endTime.toISOString(),
        firstRequestTime: this.user?.otpFirstRequestTime || '',
        requestCount: this.user?.otpRequestCount ?? 0,
      };
      localStorage.setItem(this.getCooldownStorageKey(), JSON.stringify(state));
    } catch (e) {}
  }

  private persistOtpCounts() {
    try {
      const key = this.getCooldownStorageKey();
      const existing = localStorage.getItem(key);
      const state: any = existing ? JSON.parse(existing) : {};
      state.firstRequestTime = this.user?.otpFirstRequestTime || '';
      state.requestCount = this.user?.otpRequestCount ?? 0;
      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {}
  }

  private clearPersistedCooldown() {
    try {
      localStorage.removeItem(this.getCooldownStorageKey());
    } catch (e) {}
  }

  rehydrateCooldown(): boolean {
    try {
      const raw = localStorage.getItem(this.getCooldownStorageKey());
      if (!raw) return false;
      const state = JSON.parse(raw);
      if (!state) return false;

      // Restore counters regardless of whether cooldown endTime exists
      if (state.firstRequestTime) {
        this.user.otpFirstRequestTime = state.firstRequestTime;
      }
      if (typeof state.requestCount === 'number') {
        this.user.otpRequestCount = state.requestCount;
      }

      // Expire the 15-min window if it lapsed
      if (this.user.otpFirstRequestTime) {
        let firstTimeStr = this.user.otpFirstRequestTime;
        if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
        const elapsed = Date.now() - new Date(firstTimeStr).getTime();
        if (elapsed >= this.OTP_WINDOW_MS) {
          this.user.otpRequestCount = 0;
          this.user.otpFirstRequestTime = '';
          this.clearPersistedCooldown();
          return false;
        }
      }

      if (!state.endTime) return false;
      const endTime = new Date(state.endTime);
      const remaining = endTime.getTime() - Date.now();
      if (isNaN(endTime.getTime()) || remaining <= 0) {
        return false;
      }
      this.otpCooldownEndTime = endTime;
      this.otpResendBlocked = true;
      this.startCooldownTimer();
      return true;
    } catch (e) {
      return false;
    }
  }
}
